export default __webpack_public_path__ + "static/media/jaipur2.b3dcaa0d.jpg";